import { Component } from '@theme/component';

class LanoelFooterComponent extends Component {
  #controller;
  #position;
  #newsletter;
  #brand;
  #mobile;

  connectedCallback() {
    super.connectedCallback();
    if (this.dataset.pageType !== 'index') return;
    this.#controller?.abort();
    const grid = this.querySelector('.footer-content');
    this.#brand = this.querySelector('.lanoel-footer-brand');
    this.#newsletter = grid?.querySelector(':scope > .email-signup-block');
    if (!this.#newsletter || !this.#brand) return;
    this.#position = document.createComment('');
    this.#newsletter.before(this.#position);
    this.#mobile = window.matchMedia('(max-width: 749px)');
    this.#controller = new AbortController();
    this.#mobile.addEventListener('change', this.#arrange, { signal: this.#controller.signal });
    this.#arrange();
  }

  updatedCallback() {
    super.updatedCallback();
    this.disconnectedCallback();
    this.connectedCallback();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    if (this.#position?.parentNode && this.#newsletter) {
      this.#position.after(this.#newsletter);
      this.#position.remove();
    }
    this.#position = undefined;
    super.disconnectedCallback();
  }

  #arrange = () => {
    if (!this.#newsletter || !this.#brand || !this.#position?.parentNode) return;
    if (this.#mobile.matches) this.#brand.before(this.#newsletter);
    else this.#position.after(this.#newsletter);
  };
}

if (!customElements.get('lanoel-footer-component')) {
  customElements.define('lanoel-footer-component', LanoelFooterComponent);
}
